module.exports = __webpack_public_path__ + "img/006.bbded5f3.png";